"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconTruckDoubleDrop = function SvgIconTruckDoubleDrop(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "truck double drop icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Truck Double Drop Icon'), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.887 24.673h7.732l3.083-4.03h3.502v-6.718h6.891L44 20.643v8.397h-3.272c0 2.778-2.195 5.035-4.904 5.035-2.71 0-4.905-2.257-4.905-5.035H17.081c0 2.778-2.198 5.035-4.907 5.035-2.708 0-4.904-2.257-4.904-5.035H4v-8.397h10.804zm17.937 6.885c1.354 0 2.453-1.13 2.453-2.518 0-1.395-1.099-2.518-2.453-2.518-1.356 0-2.453 1.123-2.453 2.518 0 1.387 1.097 2.518 2.453 2.518zM9.72 29.04c0 1.387 1.099 2.518 2.453 2.518 1.353 0 2.453-1.13 2.453-2.518 0-1.395-1.1-2.518-2.453-2.518-1.354 0-2.453 1.123-2.453 2.518zm24.468-8.397h7.298l-3.21-4.197H34.19z"
  }));
};

var _default = SvgIconTruckDoubleDrop;
exports.default = _default;